import Vue from 'vue';
import Router from 'vue-router';
import { config } from './shared/app.config';
import store from './store/store';

const languages = config.locales.join('|');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '',
          name: 'homePublic',
          component: () => import('./views/pages/Home.vue'),
        },
        {
          path: '/faqs',
          name: 'faqs',
          component: () => import('./views/pages/Faqs.vue'),
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
        },
        {
          path: '/reset-password/:token/:email',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
        },
        {
          path: '/error-404',
          name: 'error-404',
          props: true,
          component: () => import('@/views/pages/Error404.vue'),
        },
        {
          path: '/aviso-legal',
          name: 'avisoLegal',
          props: true,
          component: () => import('@/views/pages/AvisoLegal.vue'),
        },
        {
          path: '/condiciones-de-uso',
          name: 'terminosCondiciones',
          props: true,
          component: () => import('@/views/pages/PoliticaPrivacidad.vue'),
        },
        {
          path: '/cookies',
          name: 'cookies',
          props: true,
          component: () => import('@/views/pages/Cookies.vue'),
        },
      ],
    },
    {
      path: '/admin',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('checkToken');
        next();
      },
      children: [
        {
          path: '',
          name: 'home',
          redirect: 'products',
          component: () => import('./views/Dashboard.vue'),
        },
        {
          path: 'products',
          name: 'dishes',
          component: () => import('./views/DishesList.vue'),
        },
        {
          path: 'cartes',
          name: 'cartes',
          component: () => import('./views/CartesList.vue'),
        },
        {
          path: 'new-carte',
          name: 'new-carte',
          component: () => import('./views/CarteNew.vue'),
        },
        {
          path: 'edit-carte/:id',
          name: 'edit-carte',
          component: () => import('./views/CarteEdit.vue'),
        },
        {
          path: 'edit-sale/:id',
          name: 'edit-sale',
          component: () => import('./views/SaleEdit.vue'),
        },
        {
          path: 'report/:id',
          name: 'report',
          component: () => import('./views/ReportView.vue'),
        },
        {
          path: 'menus',
          name: 'menus',
          component: () => import('./views/MenusList.vue'),
        },
        {
          path: 'new-menu',
          name: 'new-menu',
          component: () => import('./views/MenuNew.vue'),
        },
        {
          path: 'edit-menu/:id',
          name: 'edit-menu',
          component: () => import('./views/MenuEdit.vue'),
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('./views/UsersList.vue'),
        },
        {
          path: 'users/:id',
          name: 'user',
          component: () => import('./views/UserView.vue'),
        },
        {
          path: 'restaurant',
          name: 'restaurant',
          component: () => import('./views/RestaurantView.vue'),
        },
        {
          path: 'restaurant/edit',
          name: 'editRestaurant',
          component: () => import('./views/RestaurantEdit.vue'),
        },
        {
          path: 'sales',
          name: 'sales',
          component: () => import('./views/Sales.vue'),
        },
        {
          path: 'dish-groups',
          name: 'dish-groups',
          component: () => import('./views/DishGroups.vue'),
        },
        {
          path: 'dish-groups/new',
          name: 'new-dish-group',
          component: () => import('./views/NewDishGroup.vue'),
        },
        {
          path: 'dish-groups/assign/:id',
          name: 'assign-dish-group',

          component: () => import('./views/DishGroupAssign.vue'),
        },

        {
          path: 'dish-groups/edit/:id',
          name: 'edit-dish-group',
          component: () => import('./views/EditDishGroup.vue'),
        },

        {
          path: 'coupons',
          name: 'coupons',
          component: () => import('./views/CouponsList.vue'),
        },
        {
          path: 'coupons/new',
          name: 'new-coupon',
          component: () => import('./views/NewCoupon.vue'),
        },
        {
          path: 'edit-coupon/:id',
          name: 'edit-coupon',
          component: () => import('./views/CouponEdit.vue'),
        },
        {
          path: 'sales/new',
          name: 'new-sale',
          component: () => import('./views/SaleNew.vue'),
        },
        {
          path: 'sales/new/:idProduct',
          name: 'new-sale-product',
          component: () => import('./views/SaleNew.vue'),
        },
        {
          path: 'barman/new',
          name: 'newBarman',
          component: () => import('./views/BarmanNew.vue'),
        },
        {
          path: 'barman/edit/:id',
          name: 'editBarman',
          component: () => import('./views/BarmanEdit.vue'),
        },
        {
          path: 'tickets',
          name: 'tickets',
          component: () => import('./views/TicketsList.vue'),
        },
        {
          path: 'invoices',
          name: 'invoices',
          component: () => import('./views/InvoiceList.vue'),
        },
        {
          path: 'invoices/new/:id',
          name: 'invoice',
          component: () => import('./views/InvoiceNew.vue'),
        },
        {
          path: 'invoices/edit/:id',
          name: 'editInvoice',
          component: () => import('./views/InvoiceEdit.vue'),
        },
        {
          path: 'attachment',
          name: 'attachment',
          component: () => import('./views/AttachmentView.vue'),
        },
        {
          path: 'pop-ups',
          name: 'pop-ups',
          component: () => import('./views/PopUps.vue'),
        },
        {
          path: 'pop-ups-restaurant',
          name: 'pop-ups-restaurant',
          component: () => import('./views/PopUpsRestaurant.vue'),
        },
        {
          path: 'generic-banner',
          name: 'generic-banner',
          component: () => import ('./views/GenBannerList.vue')
        },
        {
          path: 'restaurant-banner',
          name: 'restaurant-banner',
          component: () => import ('./views/ResBannerList.vue')
        }
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      beforeEnter: (to, from, next) => {
        store.commit('checkNavLanguage', next());
      },
      children: [
        {
          path: `/rest/:lang(${languages})/:slug/carta/:id`,
          name: 'publicCarta',
          component: () => import('./views/CartaPublicView.vue'),
        },
        {
          path: `/rest/:lang(${languages})/:slug/menu/:id`,
          name: 'publicMenu',
          component: () => import('./views/MenuPublicView.vue'),
        },
        {
          path: `/rest/:lang(${languages})/dish-group/:id`,
          name: 'publicDishGroup',
          component: () => import('./views/ViewDishGroup.vue'),
        },
        {
          path: `/rest/:lang(${languages})/:slug/product/:id`,
          name: 'publicDish',
          component: () => import('./views/DishPublicView.vue'),
        },
        {
          path: `/rest/:lang(${languages})/:slug`,
          name: 'publicRestaurant',
          component: () => import('./views/RestaurantPublicView.vue'),
        },
        {
          path: '/qr/:id',
          name: 'qr',
          beforeEnter: (to, from, next) => {
            store.dispatch('redirectQR', to.params.id);
          },
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Error404.vue'),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // Remove initial loading

  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/forgot-password', '/reset-password'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  const regexResetPassword = /reset-password/g;
  const isResetPassword = regexResetPassword.exec(to.path);

  let regexRestaurant = `(${languages})/(.*)`;
  regexRestaurant = new RegExp(regexRestaurant, 'g');
  const isRestaurantPublic = regexRestaurant.exec(to.path);

  let regexCarte = `(${languages})/(.*)/carta/([0-9])+`;
  regexCarte = new RegExp(regexCarte, 'g');
  const isCartePublic = regexCarte.exec(to.path);

  let regexMenu = `(${languages})/(.*)/menu/([0-9])+`;
  regexMenu = new RegExp(regexMenu, 'g');
  const isMenuPublic = regexMenu.exec(to.path);

  let regexDish = `(${languages})/(.*)/product/([0-9])+`;
  regexDish = new RegExp(regexDish, 'g');
  const isDishPublic = regexDish.exec(to.path);

  const regexAdmin = /admin\/(.*)+/g;
  const isAdmin = regexAdmin.exec(to.path);

  /* if (authRequired && !loggedIn && isResetPassword === null && isRestaurantPublic === null && isCartePublic === null && isMenuPublic === null && isDishPublic === null) {
      return next('/login');
    } */
  if (isAdmin && !loggedIn) {
    return next('/login');
  }

  // TODO. Comprobar si el token está a punto de caducar para avisar al usuario si quiere extender su sesión sin loguearse, entonces se llama a refresh token
  // if (authRequired && loggedIn && JSON.parse(loggedIn).expires_in < new Date().getTime()) {
  //   if (JSON.parse(loggedIn).rememberme) {
  //     store.dispatch('refreshToken');
  //   }
  // }
  next();
});

export default router;
